import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { highlightedPersonSelector, setHighlightedPerson } from 'features/details/highlight';

/**
 * Hover a person (asset or user id) in any list to light up the same person in every other list.
 * Spread `hoverProps` on the element that represents the person; without an id nothing happens.
 */
export const usePersonHighlight = (personId?: string | null) => {

  const dispatch = useDispatch();
  const highlightedId = useSelector(highlightedPersonSelector);
  const highlighted = !!personId && highlightedId === personId;
  const onMouseEnter = useCallback(() => dispatch(setHighlightedPerson(personId ?? null)), [dispatch, personId]);
  const onMouseLeave = useCallback(() => dispatch(setHighlightedPerson(null)), [dispatch]);
  const hoverProps = useMemo(() => (personId ? { onMouseEnter, onMouseLeave } : {}), [personId, onMouseEnter, onMouseLeave]);

  return { highlighted, hoverProps };

};
